import dayjs from 'dayjs';

/**
 * Formats a post card's publish date.
 *
 * `fullDate` cards (kanban, stage-grouped lists) are not under a date header, so the day has to
 * carry itself. There the year is added whenever the post is not from the current year, so posts
 * dragged in from a past year are not mistaken for this year's.
 */
export const formatPostDate = (publishAt: string, timezone?: string, fullDate?: boolean): string => {
    const date = timezone ? dayjs(publishAt).tz(timezone) : dayjs(publishAt);

    if (!fullDate) {
        return date.format('HH:mm');
    }

    const isOtherYear = date.year() !== dayjs().year();

    return date.format(isOtherYear ? 'D MMMM YYYY HH:mm' : 'D MMMM HH:mm');
};
